module.exports = __webpack_public_path__ + "static/media/Hest.1d3089d1.PNG";